<template>
    <div>
        <!-- 搜索栏 & 标签页 -->
        <order-search
            :start="startDate"
            :end="endDate"
            @handle-start="handleStart"
            @handle-end="handleEnd"
            @handle-search="getData">
        </order-search>
        <order-tabs
            v-model="tab"
            :tabs-list="tabList"
            @tab-click="getData">
        </order-tabs>
        <!-- 表格 -->
        <center-order-table
            table-title="服务订单"
            :table-list="orderTableList">
            <!-- 价格 -->
            <template #price="{price}">
                <div>{{"¥ " + price}}</div>
            </template>
            <!-- 实付款 -->
            <template #payment="{price}">
                <div>{{"¥ "+ price}}</div>
            </template>
            <!-- 交易状态 -->
            <template #status="{status, id}">
                <div>{{status | ostatus}}</div>
                <router-link
                    :to="{
                        name: 'memberOrder',
                        query:{id}
                    }">
                    订单详情
                </router-link>
            </template>
            <!-- 操作 -->
            <template #handle="{row}">
                <div class="order-handle">
                    <!-- 待支付 -->
                    <a href="javascript:;"
                        v-if="row.orderStatus == 0"
                        @click="$router.push({name: 'memberOrder',query: {id:row.orderID}})">
                        支付
                    </a>
                    <!-- 取消订单 -->
                    <a href="javascript:;"
						            v-if="row.orderStatus == 0"
                        @click="handleStatus(row.orderID, -1)">
                        取消订单
                    </a>
                    <a href="javascript:;"
                       v-if="row.orderStatus == 3"
                       @click="handleStatus(row.orderID, 5)">
                      退款
                    </a>
                    <a href="javascript:;"
                       v-if="row.orderStatus == 3"
                       @click="handleStatus(row.orderID, 9)">
                      完成订单
                    </a>
                </div>
            </template>
        </center-order-table>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import order from '@/mixins/centerOrder'

    export default {
        filters: {
            ostatus(val){
                switch(Number(val)){
                    case 0:
                        return "待付款";
                    case 2:
                        return "待确认";
                    case 3:
                        return "交易中";
                    case 4:
                        return "已拒绝";
                    case 5:
                        return "退款中";
                    case 6:
                      return "已退款";
                    case 9:
                      return "已完成";
                    case -1:
                        return "已取消";
                    case -2:
                        return "已过期";
                }
            },
        },
        mixins: [ order ],
        data() {
            return {
				        tab:"-3",
                tabList: [
                    {
                        value: '-3',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '待付款'
                    },
                    {
                        value: '2',
                        label: '待确认'
                    },
                    {
                        value: '3',
                        label: '交易中'
                    },
                    {
                        value: '5',
                        label: '退款中'
                    },
                    {
                      value: '6',
                      label: '已退款'
                    },
                    {
                        value: '-1',
                        label: '已取消'
                    },
                    {
                      value: '9',
                      label: '已完成'
                    },
                    {
                        value: '-2',
                        label: '过期订单'
                    }
                ]
            }
        },
        computed: mapState({
            user_id: state => state.user.user_id,
            orderTableList: state => state.order.orderTableList
        }),
        methods: {
            ...mapMutations([
                'handleLoading',
                'setCenterOrder'
            ]),
            ...mapActions([
                'getCenterOrder',
                'handleOrderStatus'
            ]),
            getParams() {
                let userID = this.user_id,
                    fromTime = this.startDate,
                    toTime = this.endDate,
                    //orderStatus = this.tab == '-3'? '0': this.tab;
                    orderStatus = this.tab;
                return this.$qs.stringify({
                    userID,
                    fromTime,
                    toTime,
                    orderStatus,
                    type: 1
                })
            },
            getData() {
                let url = 'usercenter/ushoporder',
                    params = this.getParams();
                this.getCenterOrder({
                    url,
                    params
                })
            },
            handleStatus(orderID, status) {
                this.$confirm('是否更改订单状态？', '提示' ,{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleLoading(true);

                    let url = '/usercenter/ushopOrderStatus',
                        params = this.$qs.stringify({
                            userID: this.user_id,
                            orderID,
                            status: status
                        });

                    return this.handleOrderStatus({
                        url,
                        params
                    })
                }).then(res => {
                    let code = res.data.code == 200;
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: code? 'success': 'error'
                    })
                    code && this.getData();
                }).catch(() => {
                }).finally(() => {
                    this.handleLoading(false);
                })
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.getData();
            })
        },
        beforeRouteUpdate(to, from, next) {
            next();
        },
        beforeRouteLeave (to, from, next) {
            this.setCenterOrder([]);
            next();
        }
    }
</script>

<style scoped>
.order-handle > a {
    display: block;
}
</style>
